// extracted by mini-css-extract-plugin
export default {"container":"title_container__RaQTb","text":"title_text__42xfc"};